import { IUsersActivity } from '../../core/models/usersActivityData';

function usersActivityKey(users: Array<IUsersActivity>): string {
	return [...users]
		.sort((a: IUsersActivity, b: IUsersActivity) => a.id - b.id)
		.map((user: IUsersActivity) => `${user.id}:${user.opened_tabs}`)
		.join('|');
}

export function isSameUsersActivity(left: Array<IUsersActivity>, right: Array<IUsersActivity>): boolean {
	return usersActivityKey(left) === usersActivityKey(right);
}

export function findPlanogramForActivityUpdate(
	byPlanogramId: Map<number, Array<IUsersActivity>>,
	activity: Array<IUsersActivity>
): number | null {
	let bestPlanogramId: number | null = null;
	let bestScore: number = -1;

	for (const [planogramId, cached] of byPlanogramId) {
		if (isSameUsersActivity(cached, activity)) continue;

		const cachedIds: Set<number> = new Set(cached.map((user: IUsersActivity) => user.id));
		let intersection: number = 0;

		activity.forEach((user: IUsersActivity) => {
			if (cachedIds.has(user.id)) intersection++;
		});

		if (intersection === 0 && cached.length > 0 && activity.length > 0) continue;

		const score: number = intersection * 1000 + Math.abs(cached.length - activity.length);

		if (score > bestScore) {
			bestScore = score;
			bestPlanogramId = planogramId;
		}
	}

	return bestPlanogramId;
}

export function mergePlanogramUsersActivity(byPlanogramId: Map<number, Array<IUsersActivity>>): Array<IUsersActivity> {
	const byUserId: Map<number, IUsersActivity> = new Map();

	byPlanogramId.forEach((planogramActivity: Array<IUsersActivity>) => {
		planogramActivity.forEach((user: IUsersActivity) => {
			const existing: IUsersActivity | undefined = byUserId.get(user.id);

			if (!existing) {
				byUserId.set(user.id, { ...user });
				return;
			}

			existing.opened_tabs = Math.max(existing.opened_tabs, user.opened_tabs);
		});
	});

	return Array.from(byUserId.values());
}
